import _ from 'lodash'
import React, { useState } from 'react'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { YesNoRendererComponent } from './yes-no-renderer.component'
import { currency, format } from '../services/common.service'
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { ExpandTableContainer } from '../expand-table/containers/expand-table.container'
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { selectCurrent } from '../../redux/settings/selectors';
import { settings } from '../../redux/settings/actions';
import { UploadDeleteModal } from '../../models/DeleteModal';
import PaginationContainer from './form/pagination/container/pagination.container'
import { useConfirm } from '../../hooks/useConfirm'
import { FilterDrawerComponent } from './filter-drawer'
import { Menu } from '@headlessui/react'
import { ValueComponent } from './value.component'
const Table = ({IsPublishParticularVendorToCloud,handleParticularOrgRegistry,handleOnboard,setPageSize,subColumnDefs,handleSubscribeForOpenNetwork,onSearch = () => {},	enableFilter = false,
filterTypeLists, handleAddToLocalDbnpRegistry, handleEnableOpenNetworkRegistry, handleManuallyEnableOpenNetworkRegistry, IsActionButton, IsChangeSubscription,handleChangeSubscription,IsUpgradeSubscription,handleUpgradeSubscription,
	columnData,rowData,onEdit,additionButtons,onDelete,headingName,paginationData,setPageData}:any) => {
		const { confirm, modal } = useConfirm();
		const [anchorShipmentEl, setAnchorShipmentEl] = useState(null);
		const handleClickDelete = async (data: any) => {
			const isConfirmed = await confirm('Are you sure you want to delete ?');
			if (isConfirmed) {
				handleDelete(data)			
			}
		};
		
	const [isExpand, setIsExpand] = useState(false);
  const [subRowData, setSubRowdata] = useState<any>();
  const [subRowDataId, setSubRowdataId] = useState<any>();
  const [showFilter, setShowFilter] = useState(false);
  const handleSubRowData=(data: any)=>{
    setIsExpand(!isExpand)
    if (data?.value) {
		setSubRowdataId(data?.Id)
		setSubRowdata(data?.value)
	  } else if (data?.AssociatedDomains) {
		setSubRowdataId(data?.Id)
		setSubRowdata(data?.AssociatedDomains)
	  }
    
  }
	const filteredFields = _.filter(
        columnData,
        (item) => item.field !== 'Sl' && item.field !== 'Edit'
      )
      const [isCheckAll, setIsCheckAll] = useState(false)
	  
	const handleEdit = (item: any) => {
		onEdit(item)
	}

	const handleDelete = (item: any) => {
        onDelete(item)
	}

	const handleCheckbox = (id: any) => {

	}

	const handleSelectAll = (e: any) => {

	}
	const hasCustomPagination = paginationData && "current" in paginationData && "pageSize" in paginationData;

	const [filteredData, setFilteredData] = useState<any>(rowData);
      const { PageNumber, PageSize } = paginationData || { PageNumber: 1, PageSize: 10 };
      const startIndex = (PageNumber - 1) * PageSize + 1;
  return (

	  <>
	  <div className=" w-full bg-white shadow-xl p-4 rounded ">
				<div className="flex my-2  w-full justify-between items-center px-2">
					<div className="uppercase text-xl">
						{headingName ? headingName : ''}
					</div>
					{enableFilter && <FilterDrawerComponent 
						columnData={columnData} 
						rowData={rowData} 
						filterTypeLists={filterTypeLists} 
						setFilteredData={setFilteredData} 
						initiateSearch={onSearch}
						showFilter={showFilter} 
						setShowFilter={setShowFilter}
					/>}
					<div className="flex flex-row">
						{/* <div className="flex flex-row items-center justify-center text-gray-600">
						<input type="search" name="serch"  placeholder={`Search ${headingName ? headingName : 'Domains'}...`} className="bg-white h-10 w-full xl:w-64 px-5 rounded-lg border text-sm focus:outline-none" />
							<button type="submit" className="absolute right-0 top-0 mt-5 mr-4">
								<svg className="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 56.966 56.966"
									width="512px" height="512px">
									<path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
								</svg>
							</button>
						</div> */}
						{/* <div className=' py-2'>
						<svg className="h-7 w-7 mx-3 pt-2" viewBox="0 0 24 24" fill="#ffffff">
							<path d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" fill="#1C274C" />
						</svg>
						</div> */}
			  {additionButtons?.length && additionButtons.map((button: any) => (
				  <button
					  onClick={(event) => button.callback(event)}
					  type="button"
					  className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
				  >
					  <span className=''>{button.svg}</span>
					  <span className=''>{button.name}</span>

				  </button>
			  ))}

{enableFilter && <button
								onClick={() => setShowFilter(!showFilter)}
								type="button"
								className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "								
							>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
								<path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</button>}
					</div>
				</div>
				<div className="h-[500px] overflow-auto">
				{filteredData?.length !== 0 ?	<table className="w-full text-xs bg-red-50">
						<thead className="w-full border-y border-black border-opacity-20 ">
							<tr key={'table'} className="w-full text-left h-12">
								<th key={0}
									className="px-5">
									<input
										checked={isCheckAll}
										type="checkbox"
										name="selectAll"
										id="selectAll"
										onChange={(e: any) => handleSelectAll(e)} />
								</th>
							{!hasCustomPagination && 
								<th key={1}>
											#
										</th>}
								{columnData[0]?.isSortLabel ?
							  filteredFields.map((column: any, index: any) => (
								  <th key={index}
									  className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10">{column.headerName}</th>

							  ))
							  :
							  filteredFields.map((column: any, index: any) => (
								  <th key={index}
									  className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10">
									  {column.headerName}
								  </th>

							  ))}
						  <th
							  className=" border-r-2  last:border-r-0 w-auto px-10">
							  Action
						  </th>
							</tr>
						</thead>
						<tbody className="bg-red-400 text-sm font-light max-h-24 overflow-y-auto">
						<>
						{filteredData && filteredData?.map((row: any, index: any) => (
								 <><tr key={row}
								className="w-full cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
								<td key={0}>
									<span className="px-5">
										<input
											type="checkbox"
											defaultChecked={false}
											onChange={(e) => handleCheckbox(e)}
											checked={false} />
									</span>
								</td>
								{!hasCustomPagination && 
								<td key={1}>
											{startIndex + index}
										</td>}
								{filteredFields.map((column) => {
									const dataValue: any = _.property(column.field)(row)
									return (

										<>
											<td key={index} className="px-10  w-auto">
												{!column.valueFormatter  && column.cellRenderer !== 'imageRenderer' && column.isDateValueFormat !== true && column.isCurrencyValueFormat !== true && column.cellRenderer !== 'yesNoRenderer' && <div
																className={`w-auto max-w-40 truncate ${column?.align} ${column?.isEdit ? 'underline cursor-pointer' : ''} ${column?.callback ? 'underline cursor-pointer hover:font-bold' : ''}`}
																title={dataValue}
																onClick={() => {
																	if (column?.callback) {
																		column.callback(row);
																	}
																}}
															>
																{/* {dataValue?.length > 40 ? `${dataValue.substring(0, 25)}...` : dataValue} */}
																{dataValue}
															</div>
														}
												
												{column.isDateValueFormat === true && (
													<p>
														{format(dataValue)}
													</p>
												)}
												{column.isCurrencyValueFormat === true && (
                                  <p >
                                    {currency(dataValue)}
                                  </p>
                                )}
								{column.valueFormatter && (
															<ValueComponent value={dataValue} valueFormatter={column.valueFormatter} />
														)}
												{column.cellRenderer === 'yesNoRenderer' && (
													<YesNoRendererComponent
														cellRenderer={column.cellRenderer}
														value={dataValue} />
												)}
												 {column.isGlobalOrgRegistry &&
                                   <button
                                   type="button"
								   className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
                                   onClick={() => handleSubscribeForOpenNetwork(row)}
                                 >
                                  Subscribe 
								   </button>}
								   {/* {column.isAddLocalDBNPRegistry &&
                                   <button
                                   type="button"
								   className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
                                   onClick={() => handleAddToLocalDbnpRegistry(row)}
                                 >
                                  Add To LocalDbnpRegistry 
								   </button>} */}
								   	{column.cellRenderer === 'imageRenderer' && (
															<img src={dataValue} className="w-16 h-16 object-contain" />
														)}
												{column.isExpanded &&

													<button
														aria-label="expand row"
														className="p-2 text-2xl"

														onClick={() => handleSubRowData(row)}
													>
														{isExpand ? <HiChevronUp /> : <HiChevronDown />}
													</button>}
											</td>

										</>
									)
								})}

<td key={9} className="flex p-5 w-max flex-row justify-center item-baseline cursor-pointer">
	{modal}
											<div className="flex items-center">
												<div className='flex flex-row justify-center items-center'>
								{onEdit && <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleEdit(row)} width="12" height="12" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>}
								{onDelete && <div><svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleClickDelete(row)} width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>{modal}</div>}
								{IsActionButton &&
													<Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }} >
																<div className="px-1 py-1">
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleAddToLocalDbnpRegistry(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${row.IsAddToLocalDBNPRegistration === false ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
																				}`}
																			title="Add open network registry to Local DBNP registry"
																			disabled={row.IsAddToLocalDBNPRegistration === true}
																			>
																				Add to Global DBNP Registry
																			</button>
																		)}
																	</Menu.Item>
																	{/* <Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleEnableOpenNetworkRegistry(row);
																					setAnchorShipmentEl(null);
																				}}
																			className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${row.IsAddToLocalDBNPRegistration === false ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
																				}`}
																			title="Enable Open Network Registry"
																			disabled={row.IsAddToLocalDBNPRegistration === true}
																			>
																				Enable Registry
																			</button>
																		)}
																	</Menu.Item> */}
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleManuallyEnableOpenNetworkRegistry(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${row.IsAddToLocalDBNPRegistration === false ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
																				}`}

																			title="Update Open Network Registry"
																			disabled={row.IsAddToLocalDBNPRegistration === true}
																			>
																				Update OBN Registry
																			</button>
																		)}
																	</Menu.Item>
																</div>
															</Menu.Items>)}
													</Menu>
												}


{IsChangeSubscription &&
													<Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }} >
																<div className="px-1 py-1">
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleChangeSubscription(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black 
																				}`}
																			title="change Subscription from one to other"
																			
																			>
																				Change Subscription
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleOnboard(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black 
																				}`}
																			title="Onboarding Details of the subscribed Business"
																			
																			>
																				OnBoarding Details
																			</button>
																		)}
																	</Menu.Item>
																</div>
															</Menu.Items>)}
													</Menu>
												}

												
{IsUpgradeSubscription &&
													<Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }} >
																<div className="px-1 py-1">
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleUpgradeSubscription(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black 
																				}`}
																			title="change Subscription from one to other"
																			
																			>
																				Upgrade Subscription
																			</button>
																		)}
																	</Menu.Item>
																	
																</div>
															</Menu.Items>)}
													</Menu>
												}

												{IsPublishParticularVendorToCloud &&
													<Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }} >
																<div className="px-1 py-1">
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleParticularOrgRegistry(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																				} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black 
																				}`}
																			title="change Subscription from one to other"
																			
																			>
																				Publish to Global
																			</button>
																		)}
																	</Menu.Item>
																	
																</div>
															</Menu.Items>)}
													</Menu>
												}

												
								</div>
								</div>
								</td>
							</tr>
							<ExpandTableContainer
									subRowData={subRowData}
									isExpand={isExpand}
									subRowDataId={subRowDataId}
									subColumnDefs={subColumnDefs}
									row={row}
									columnData={columnData} /></>
						)
					)
				}
				</>
						</tbody>
					</table>
					:
					<div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
				</div>
				{rowData?.length !== 0 ?  <div className="flex items-center justify-center w-full gap-8 my-2">
				<PaginationContainer 
                        pages={paginationData} 
                        handleChangeRowsPerPage={setPageSize} 
                        handleFirstPageButtonClick={() => setPageData(1)}
						handleBackButtonClick={() =>setPageData(paginationData?.PageNumber - 1)}
                        handleNextButtonClick={() => setPageData(paginationData?.PageNumber + 1)}
                        handleLastPageButtonClick={() => setPageData(paginationData?.TotalPages || 1)}
                    />	</div>:''}
			</div>
	   {/* {additionButtons?.length && <div className=' flex w-full justify-end items-end '>
			  {additionButtons.map((button: any) => (
				  <button
					  onClick={(event) => button.callback(event)}
					  type="button"
					  className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
				  >
					  {button.name}
				  </button>
			  ))}



		  </div>} 
	  <div className="min-h-[450px] w-full flex justify-center overflow-auto bg-white bg-opacity-25 shadow-xl p-4 rounded">

			  {rowData?.length !== 0 ? <table className="w-screen text-xs justify-center">

				  <thead className="w-full border-y border-black border-opacity-10 ">
					  <tr key={'table'} className="w-full text-left h-12">
						  <th key={0}
							  className="px-5 border-r-2  last:border-r-0 w-auto">
							  <input
								  checked={isCheckAll}
								  type="checkbox"
								  name="selectAll"
								  id="selectAll"
								  onChange={(e: any) => handleSelectAll(e)} />
						  </th>
						  {columnData[0]?.isSortLabel ?
							  filteredFields.map((column: any, index: any) => (
								  <th key={index}
									  className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10">{column.headerName}</th>

							  ))
							  :
							  filteredFields.map((column: any, index: any) => (
								  <th key={index}
									  className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10">
									  {column.headerName}
								  </th>

							  ))}
						  <th
							  className=" border-r-2  last:border-r-0 w-auto px-10">
							  Action
						  </th>
					  </tr>
				  </thead>
				  <tbody className="w-full ">
					  {rowData.map((row: any, index: any) => (
						  <tr key={row}
							  className="w-full  cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white  odd:bg-opacity-25">
							  <td key={0}>
								  <span className="px-5   w-auto justify-center">
									  <input
										  type="checkbox"
										  defaultChecked={false}
										  onChange={(e) => handleCheckbox(e)}
										  checked={false} />
								  </span>
							  </td>
							  {filteredFields.map((column) => {
								  const dataValue: any = _.property(column.field)(row)
								  return (

									  <>
										  <td key={index} className="px-10  w-auto">
											  {dataValue}
										  </td>

									  </>
								  )
							  })}
							  <td key={9} className="flex px-5 w-max flex-row  justify-start item-baseline cursor-pointer pt-6 space-x-2">
								  <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleEdit(row)} width="12" height="12" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>
								  <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleDelete(row)} width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>
							  </td>
						  </tr>
					  ))}
				  </tbody>
			  </table>
				  :
				  <div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
		  </div> */}
		  </>
		       

  )
}

export default Table